/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class Button extends Component {
  variant = 'primary'; // 'primary' | 'secondary' | 'outline' | 'ghost'
  type = 'button';
  disabled = false;
  isLoading = false;
  onClick = null;
  extraClass = null;
  // Optional native tooltip shown on hover.
  title = null;
}
